import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-sensorimage',
  templateUrl: './sensorImage.component.html',
  styleUrls: ['../IconDesings.scss'],
})

export class SensorImageComponent {
  constructor() {
  }
}